// Interface for AppContext value
import { DirectoryListType } from '../components/directory-list/DirectoryList';
import { IResultState } from '../lib/resultInterfaces';
import IDoctorSpecialty from '../interfaces/IDoctorSpecialty';
import IFacilitySpecialty from '../interfaces/IFacilitySpecialty';
import IGenericResult from '../interfaces/IGenericResult';
import { IPlan } from '../interfaces/IPlan';
import IDistance from '../interfaces/IDistance';
import { distanceOptions } from '../lib/util';
import IOrigin from '../interfaces/IOrigin';
import ISearch from '../interfaces/ISearch';

export interface IAppContext {
  isDirectorySelected: boolean;
  directoryListType: DirectoryListType | string;
  cacheTime: string;
  stateList: IResultState[];
  plansData: IPlan[];
  plan: IPlan | null;
  planCode: string | undefined;
  planName: string;
  shortPlanName: string;
  planState: string;
  disclaimerUrl: string;
  doctorSpecialties: IDoctorSpecialty[] | null;
  facilitySpecialties: IFacilitySpecialty[] | null;
  pharmacySpecialties: string[] | null;
  selectedSpecialty: string;
  chosenSpecialty: string;
  reportYear: number;
  location: string;
  //origin: IOrigin;
  isDisabled: boolean;
  search: ISearch;
  distance: IDistance;
  name: string;
   pcp?: string | null; 
   updatePCP: (x: string | null) => void;
  results: IGenericResult[][];
  displayedResults: IGenericResult[];
  sitePlans: IPlan[];
  updateSelected: (x: boolean) => void;
  updateListType: (x: DirectoryListType) => void;
  updateCacheTime: (x: string) => void;
  updateStateList: (x: IResultState[]) => void;
  updatePlansData: (x: IPlan[]) => void;
  updatePlan: (x: IPlan) => void;
  updatePlanCode: (x: string | undefined) => void;
  updatePlanName: (x: string) => void;
  updateShortPlanName: (x: string) => void;
  updatePlanState: (x: string) => void;
  updateDisclaimerUrl: (x: string) => void;
  updateDoctorSpecialties: (x: IDoctorSpecialty[]) => void;
  updateFacilitySpecialties: (x: IFacilitySpecialty[]) => void;
  updatePharmacySpecialties: (x: string[]) => void;
  updateSelectedSpecialty: (x: string) => void;
  updateChosenSpecialty: (x: string) => void;
  updateReportYear: (x: number) => void;
  updateLocation: (x: string) => void;
  //updateOrigin: (x: IOrigin) => void;
  updateIsDisabled: (x: boolean) => void;
  updateSearch: (x: ISearch) => void;
  updateDistance: (x: IDistance) => void;
  updateName: (x: string) => void;
  updateResults: (x: IGenericResult[][]) => void;
  updateDisplayedResults: (x: IGenericResult[]) => void;
  updateSitePlans: (x: IPlan[]) => void;
}

// The default state for app context
export const defaultAppState: IAppContext = {
  isDirectorySelected: false,
  directoryListType: '',
  cacheTime: '',
  stateList: [],
  plansData: [],
  plan: null,
  planCode: '',
  planName: '',
  shortPlanName: '',
  planState: '',
  disclaimerUrl: '',
  doctorSpecialties: null,
  facilitySpecialties: null,
  pharmacySpecialties: null,
  selectedSpecialty: '',
  chosenSpecialty: '',
  reportYear: 2026,
  location: '',
  //origin: { lat: 0 , lng: 0},
  isDisabled: false,
  search: { required: false, isValidZIP: true },
  distance: distanceOptions()[0],
  name: '',
  results: [],
  displayedResults: [],
  sitePlans: [],
    pcp: null,
    updatePCP: (x) => {},
  updateSelected: (x) => {},
  updateListType: (x) => {},
  updateCacheTime: (x) => {},
  updateStateList: (x) => {},
  updatePlansData: (x) => {},
  updatePlan: (x) => {},
  updatePlanCode: (x) => {},
  updatePlanName: (x) => {},
  updateShortPlanName: (x) => {},
  updatePlanState: (x) => {},
  updateDisclaimerUrl: (x) => {},
  updateDoctorSpecialties: (x) => {},
  updateFacilitySpecialties: (x) => {},
  updatePharmacySpecialties: (x) => {},
  updateSelectedSpecialty: (x) => {},
  updateChosenSpecialty: (x) => {},
  updateReportYear: (x) => {},
  updateLocation: (x) => {},
  //updateOrigin: (x) => {},
  updateIsDisabled: (x) => {},
  updateSearch: (x) => {},
  updateDistance: (x) => {},
  updateName: (x) => {},
  updateResults: (x) => {},
  updateDisplayedResults: (x) => {},
  updateSitePlans: (x) => {}
};
